import axios from 'axios';
import axiosConfig from '../axios-config';

export const getHandshake = async (locale) => {
  let data = JSON.stringify({
    store: locale,
  });

  let config = {
    method: 'post',
    url: '/handshake',
    data: data,
  };
  try {
    const res = await axiosConfig(config);
    return res.data;
  } catch (err) {
    return err;
  }
};

export async function getServerHandshake() {
  const { cookies } = require('next/headers');
  const locale = (await cookies()).get('NEXT_LOCALE')?.value || 'ar';
  const handshake = (await cookies()).get(`phst_${locale}`)?.value;

  return handshake;
}

export const gethandshakeApiRoute = async (locale) => {
  let data = JSON.stringify({
    store: locale,
  });
  const config = {
    method: 'GET',
    url: '/api/phst',
    data: { data },
  };

  try {
    const req = await axios(config);

    return req.data;
  } catch (error) {
    console.log('error', error);
    return null;
  }
};
